import type { Nullable } from "@msuite/utils/types";
import { ActivityChart, type ActivityChartData } from "../charts";
import type { VirtuosoHandles } from "../libs/virtuoso";

interface TimelineActivityChartProps<T> {
	data: Nullable<Array<T>>;
	virtuosoHandles?: VirtuosoHandles;
	renderTooltip: (items: ActivityChartData<T>[]) => React.ReactNode;
	getDate: (item: T) => string;
}

export function TimelineActivityChart<T>({
	data,
	virtuosoHandles,
	renderTooltip,
	getDate,
}: TimelineActivityChartProps<T>) {
	/** Render */
	return (
		<ActivityChart
			data={
				data?.map(
					(item) =>
						({
							date: getDate(item),
							item,
						}) as ActivityChartData<typeof item>,
				) || []
			}
			onDateClick={(date) => {
				const index = virtuosoHandles?.indexMap.current?.get(`date-${date}`);
				if (index !== undefined && virtuosoHandles?.indexMap.current) {
					virtuosoHandles?.ref?.current?.scrollToIndex({
						index,
						align: "start",
					});
				}
			}}
			renderTooltip={renderTooltip}
		/>
	);
}
